import React from "react";
import * as Yup from "yup";
export const email = (data: any) =>
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    data
  );
export const ONLY_ALPHABATE = /^[A-Za-z\s]*$/;
export const PHONE_REGEXP = /^[6789]\d{9}$/;
export const password = (data: any) => /^(?=.*\d).{6,20}$/.test(data);
export const validateSubmitForm = Yup.object().shape({
  Name: Yup.string().required("Name is required").min(2, "Min 2 character required"),
  Mobile: Yup.string().required("Mobile is required").min(10, "Enter only 10 Digit").max(10, "Enter only 10 Digit"),
  Checkbox: Yup.bool().oneOf([true], "You must accept the terms and conditions"),
  GRecaptcha: Yup.string().required("GRecaptcha is required")?.nullable(),
  /* .required('You must accept the terms and conditions') */
  // Email: Yup.string()
  //     .required("Email is required")
  //     .email("Invalid Email address"),
  // CityId: Yup.string()
  //     .required("City is required"),
  // Message: Yup.string()
  //     .required("Message is required")
  //     .min(10, 'Min 10 character required')
});
export const DoctorDetailform = Yup.object().shape({
  Name: Yup.string().required("Name is required").min(2, "Min 2 character required"),
  Mobile: Yup.string().required("Mobile is required").min(10, "Enter only 10 Digit").max(10, "Enter only 10 Digit"),
  // CityId: Yup.string()
  // .required("City is required"),
  Checkbox: Yup.bool().oneOf([true], "You must accept the terms and conditions"),
  GRecaptcha: Yup.string().required("GRecaptcha is required")?.nullable(),
  // Email: Yup.string()
  //     .required("Email is required")
  //     .email("Invalid Email address"),
});
export const DoctorEnquiryform = Yup.object().shape({
  Name: Yup.string().required("Name is required").min(2, "Min 2 character required"),
  Mobile: Yup.string().required("Mobile is required").min(10, "Enter only 10 Digit").max(10, "Enter only 10 Digit"),
  CityId: Yup.string().required("City is required"),
  Checkbox: Yup.bool().oneOf([true], "You must accept the terms and conditions"),
  GRecaptcha: Yup.string().required("GRecaptcha is required")?.nullable(),
  // Email: Yup.string()
  //     .required("Email is required")
  //     .email("Invalid Email address"),
});
export const validateBookingEnquiry = Yup.object().shape({
  Name: Yup.string().required("Name is required").min(2, "Min 2 character required"),
  Mobile: Yup.string().required("Mobile is required").min(10, "Enter only 10 Digit").max(10, "Enter only 10 Digit"),
  CityId: Yup.string().required("City is required"),
  Checkbox: Yup.bool().oneOf([true], "You must accept the terms and conditions"),
  GRecaptcha: Yup.string().required("GRecaptcha is required")?.nullable(),
  // Gender: Yup.string()
  //     .required("Gender is required"),
  /* DOB: Yup.string().nullable().default(null)
        .required("DOB is required"), */
  // Address: Yup.string()
  //         .required("Address is required")
  //         .min(4, 'Min 4 character required')
});
export const validateUploadPrescription = Yup.object().shape({
  FirstName: Yup.string().required("First Name is required").min(2, "Min 2 character required"),
  /*  LastName: Yup.string()
        .required("Last Name is required")
        .min(2, 'Min 2 character required'), */
  Mobile: Yup.string().required("Mobile is required").min(10, "Enter only 10 Digit").max(10, "Enter only 10 Digit"),
  CityId: Yup.string().required("City is required"),
  Gender: Yup.string().required("Gender is required"),
  Checkbox: Yup.bool().oneOf([true], "You must accept the terms and conditions"),
  GRecaptcha: Yup.string().required("GRecaptcha is required")?.nullable(),
  /* Address: Yup.string()
        .required("Address is required")
        .min(4, 'Min 4 character required') */
});
/* export const sendOtpValidation = Yup.object().shape({
    MobileNo: Yup.string()
        .required("Mobile is required")
        .min(10, 'Enter only 10 Digit')
        .max(10, 'Enter only 10 Digit')
}) */
export function sendOtpValidation(values: any) {
  var errors: { [k: string]: any } = {};
  if (!values.MobileNo) {
    errors.MobileNo = "Mobile No is required.";
  } else if (values.hasOwnProperty("MobileNo") && values.MobileNo.length !== 10) {
    errors.MobileNo = "Enter only 10 Digit.";
  }
  errors.isFormValid = values && Object.keys(values).length >= 1 && Object.keys(errors).length == 0;
  return errors;
}

export const validateJobApplyForm = Yup.object().shape({
  Name: Yup.string().required("Name is required").min(2, "Min 2 character required"),
  Mobile: Yup.string().required("Mobile is required").min(10, "Enter only 10 Digit").max(10, "Enter only 10 Digit"),
  Email: Yup.string().required("Email is required").email("Invalid Email address"),
  JobId: Yup.string().required("Postion is required"),
  CityId: Yup.string().required("City is required"),
  Experience: Yup.string().required("Experience is required"),
  Checkbox: Yup.bool().oneOf([true], "You must accept the terms and conditions"),
  GRecaptcha: Yup.string().required("GRecaptcha is required")?.nullable(),
  /* OtherInformation: Yup.string()
        .required("OtherInformation is required")
        .min(10, 'Min 10 character required') */
});
export const validateAddPatient = Yup.object().shape({
  PatientFirstName: Yup.string().required("First Name is required").min(2, "Min 2 character required"),
  /* PatientLastName: Yup.string()
        .required("Last Name is required")
        .min(2, 'Min 2 character required'), */
  PatientMobile: Yup.string()
    .required("Mobile is required")
    .min(10, "Enter only 10 Digit")
    .max(10, "Enter only 10 Digit"),
  PatientGender: Yup.string().required("Gender is required"),
  /* PatientDob: Yup.string().nullable().default(null)
        .required("DOB is required"), */
  /* PatientRelation: Yup.string()
        .required("Relation is required"), */
  CustomerAddressLine1: Yup.string().required("Address is required").min(10, "Min 10 character required"),
});

export const validateAddAddress = Yup.object().shape({
  CustomerName: Yup.string().required("Name is required").min(2, "Min 2 character required"),
  CustomerEmail: Yup.string().required("Email is required").email("Invalid Email address"),
  CustomerAddressLine1: Yup.string().required("Address Line 1 is required").min(4, "Min 4 character required"),
  /* CustomerAddressLine2: Yup.string()
        .required("Address Line2 is required")
        .min(4, 'Min 4 character required'), */
  CustomerStateId: Yup.string().required("State is required"),
  CustomerCityId: Yup.string().required("City is required"),
  AddressTag: Yup.string().required("Address Tag is required"),
  CustomerLocality: Yup.string().required("Locality is required").min(4, "Min 4 character required"),
  CustomerPincode: Yup.string()
    .required("Pincode is required")
    .min(6, "Enter only 6 Digit")
    .max(6, "Enter only 6 Digit"),
});

export const validatePartner = Yup.object().shape({
  FirstName: Yup.string().required("First Name is required").min(2, "Min 2 character required"),
  /* LastName: Yup.string()
        .required("Last Name is required")
        .min(2, 'Min 2 character required'), */
  Mobile: Yup.string().required("Mobile is required").min(10, "Enter only 10 Digit").max(10, "Enter only 10 Digit"),
  /*  EmailId: Yup.string()
        .required("Email is required")
        .email("Invalid Email address"), */
  CityId: Yup.string().required("City is required"),
  Checkbox: Yup.bool().oneOf([true], "You must accept the terms and conditions"),
  GRecaptcha: Yup.string().required("GRecaptcha is required")?.nullable(),
  /* Address: Yup.string()
        .required("Address is required")
        .min(4, 'Min 4 character required') */
});
export const validateQuickLink = Yup.object().shape({
  Name: Yup.string().required("Name is required").min(2, "Min 2 character required"),
  Mobile: Yup.string().required("Mobile is required").min(10, "Enter only 10 Digit").max(10, "Enter only 10 Digit"),
  Checkbox: Yup.bool().oneOf([true], "You must accept the terms and conditions"),
  GRecaptcha: Yup.string().required("GRecaptcha is required")?.nullable(),
});
export const validateGeneralEnquiry = Yup.object().shape({
    Name: Yup.string()
        .required("Name is required")
        .min(2, 'Min 2 character required'),
    Mobile: Yup.string()
        .required("Mobile is required")
        .min(10, 'Enter only 10 Digit')
        .max(10, 'Enter only 10 Digit'),
    CityId: Yup.string()
        .required("City is required"),
        Checkbox: Yup.bool()
        .oneOf([true], 'You must accept the terms and conditions'),
        GRecaptcha: Yup.string()
        .required("GRecaptcha is required")?.nullable()
})
export const validateWelcomePopup = Yup.object().shape({
   /*  Name: Yup.string()
        .required("Name is required")
        .min(2, 'Min 2 character required'), */
    Mobile: Yup.string()
        .required("Mobile is required")
        .min(10, 'Enter only 10 Digit')
        .max(10, 'Enter only 10 Digit'),
    CityId: Yup.string()
        .required("City is required"),
        Checkbox: Yup.bool()
        .oneOf([true], 'You must accept the terms and conditions')
})
export const validateSendQueryPopup = Yup.object().shape({
   Name: Yup.string()
       .required("Name is required")
       .min(2, 'Min 2 character required'),
   Mobile: Yup.string()
       .required("Mobile is required")
       .min(10, 'Enter only 10 Digit')
       .max(10, 'Enter only 10 Digit'),
   CityId: Yup.string()
       .required("City is required"),
       Checkbox: Yup.bool()
       .oneOf([true], 'You must accept the terms and conditions')
})
export const validateHomeCollection = Yup.object().shape({
  FirstName: Yup.string().required("First Name is required").min(2, "Min 2 character required"),
  /* LastName: Yup.string()
        .required("Last Name is required")
        .min(2, 'Min 2 character required'), */
  Mobile: Yup.string().required("Mobile is required").min(10, "Enter only 10 Digit").max(10, "Enter only 10 Digit"),
  /* EmailId: Yup.string()
        .required("Email is required")
        .email("Invalid Email address"), */
    CityId: Yup.string()
        .required("City is required"),
    // Address: Yup.string()
    //     .required("Address is required")
    //     .min(4, 'Min 4 character required'),
    PreferredDate: Yup.string().nullable().default(null)
        .required("Preferred Date is required"),
    PreferredTime: Yup.string()
        .required("Preferred Time is required"),
        Checkbox: Yup.bool()
        .oneOf([true], 'You must accept the terms and conditions')
    // PackageId: Yup.string()
    //     .required("Package is required")
})
export const validateGurugramLab = Yup.object().shape({
    Name: Yup.string()
        .required("Name is required")
        .min(2, 'Min 2 character required'),
    Mobile: Yup.string()
        .required("Mobile is required")
        .min(10, 'Enter only 10 Digit')
        .max(10, 'Enter only 10 Digit'),
    CityId: Yup.string()
        .required("City is required"),
        Checkbox: Yup.bool()
        .oneOf([true], 'You must accept the terms and conditions'),
        GRecaptcha: Yup.string()
        .required("GRecaptcha is required")?.nullable()
})
export const validatePreventiveHltPkg = Yup.object().shape({
    Name: Yup.string()
        .required("Name is required")
        .min(2, 'Min 2 character required'),
    Mobile: Yup.string()
        .required("Mobile is required")
        .min(10, 'Enter only 10 Digit')
        .max(10, 'Enter only 10 Digit'),
    CityId: Yup.string()
        .required("City is required"),
        Checkbox: Yup.bool()
        .oneOf([true], 'You must accept the terms and conditions')
})
export const validatPHP = Yup.object().shape({
  Name: Yup.string().required("Name is required").min(2, "Min 2 character required"),
  Mobile: Yup.string().required("Mobile is required").min(10, "Enter only 10 Digit").max(10, "Enter only 10 Digit"),
  CityId: Yup.string().required("City is required"),
  QueryNature: Yup.string().required("QueryNature  is required"),
  Message: Yup.string().required("Message is required"),
  Checkbox: Yup.bool().oneOf([true], "You must accept the terms and conditions"),
  GRecaptcha: Yup.string().required("GRecaptcha is required")?.nullable(),
});
export const validateEditProfile = Yup.object().shape({
  first_name: Yup.string()
    .required("First Name is required")
    .min(2, "Min 2 character required")
    .max(15, "Max 15 character allowed")
    .matches(ONLY_ALPHABATE, "Enter only alphabetic."),
  last_name: Yup.string()
    .required("Last Name is required")
    .min(2, "Min 2 character required")
    .max(15, "Max 15 character allowed")
    .matches(ONLY_ALPHABATE, "Enter only alphabetic."),
  mobile_no: Yup.string()
    .required("Mobile is required")
    .matches(PHONE_REGEXP, "Enter valid number.")
    .min(10, "Enter only 10 Digit")
    .max(10, "Enter only 10 Digit"),
  email_id: Yup.string().required("Email Id is required").email("Invalid Email address"),
  gender: Yup.string().required("Gender is required"),
  dob: Yup.string().required("Date of birth is required"),
  salutation: Yup.string().required("Salutation is required"),
});
export const validateEditMember = Yup.object().shape({
  first_name: Yup.string()
    .required("First Name is required")
    .min(2, "Min 2 character required")
    .max(15, "Max 15 character allowed")
    .matches(ONLY_ALPHABATE, "Enter only alphabetic."),
  last_name: Yup.string()
    .required("Last Name is required")
    .min(2, "Min 2 character required")
    .matches(ONLY_ALPHABATE, "Enter only alphabetic.")
    .max(15, "Max 15 character allowed"),
  mobile_no: Yup.string()
    .required("Mobile is required")
    .matches(PHONE_REGEXP, "Enter valid number.")
    .min(10, "Enter only 10 Digit")
    .max(10, "Enter only 10 Digit"),
  gender: Yup.string().required("Gender is required"),
  relation: Yup.string().required("Relation is required"),
  dob: Yup.string().required("Date of birth is required"),
  salutation: Yup.string().required("Salutation is required"),
});
export const validateEditAddress = Yup.object().shape({
  AddressTag: Yup.string().required("House No is required"),
  AddressLine1: Yup.string().required("Colony/Area/Sector is required").min(2, "Min 2 character required"),
  HouseNo: Yup.string().required("House No is required"),
  StateId: Yup.string().required("State is required"),
  CityId: Yup.string().required("City is required"),
  Pincode: Yup.string().required("Pincode is required").min(6, "Min 6 digit required"),
});
export const validateCancleOrder = Yup.object().shape({
  Reason: Yup.string().required("Reason is required"),
  Message: Yup.string().when("Reason", (Reason, schema) => {
    if (Reason === "Other") {
      return schema.required("Message is required");
    } else {
      return schema;
    }
  }),
});
